export default __webpack_public_path__ + "static/media/logo.906179b0.png";